import PropTypes from 'prop-types';
import styles from './FJMyCreationsDetail.module.less';
import BackIcon from '../../../../../assets/svg/community/back-small.svg?react';
import FJCommunityMixViewList from '../../../FJCommonComponent/FJCommunityMixViewList/FJCommunityMixViewList';
import FJLocalStore from '../../../../../store/FJLocalStore';
const FJMyCreationsDetail = props => {
    const {
        active,
        myCreationsDetailInfo = {},
        gotoBack,
        myCreationsDetailList,
        getMoreData,
        myCreationsDetailPageInfo,
    } = props;
    const { categoryName } = myCreationsDetailInfo;
    const { initLoading, getMoreLoading, hasMore } = myCreationsDetailPageInfo;
    const renderAheadChildren = () => {
        return (
            <div className={styles.header}>
                <div className={styles.back} onClick={gotoBack}>
                    <BackIcon />
                </div>
                <div className={styles.title}>{FJLocalStore._(categoryName)}</div>
                <div className={styles.right}></div>
            </div>
        );
    };
    if (!active) return null;
    return (
        <FJCommunityMixViewList
            className={styles.list}
            list={myCreationsDetailList}
            getMoreData={getMoreData}
            initLoading={initLoading}
            getMoreLoading={getMoreLoading}
            hasMore={hasMore}
            active={active}
            renderAheadChildren={renderAheadChildren}
        />
    );
};

FJMyCreationsDetail.propTypes = {
    myCreationsDetailInfo: PropTypes.object.isRequired,
    gotoBack: PropTypes.func.isRequired,
    myCreationsDetailList: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired,
    getMoreData: PropTypes.func.isRequired,
    myCreationsDetailPageInfo: PropTypes.object.isRequired,
};

export default FJMyCreationsDetail;
